


export const TASK_REQUEST="TASK_REQUEST"
export const TASK_SUCCESS="TASK_SUCCESS"
export const TASK_FALIURE="TASK_FALIURE"
export const POST_TASK="POST_TASK"
export const TASK_DELETE="TASK_DELETE"
export const UPDATE_TASK="UPDATE_TASK"
export const GET_PROJECT="GET_PROJECT"